module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("03Jix"))).then(() => parcelRequire('1iHdE'));